// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components-PreviewList----index-module---root---2QxGg","header":"src-components-PreviewList----index-module---header---1Wh4b","title":"src-components-PreviewList----index-module---title---3VU4J","inner":"src-components-PreviewList----index-module---inner---2r8z_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PreviewList/index.module.css
// module id = 614
// module chunks = 168707334958949